<template>
	<div class="user-registration-layout display-flex flex-column flex-justify-space-between">
		<div
			v-if="!isInstallationMode && !hideTopBar"
			class="header-container display-flex flex-row flex-align-center flex-justify-space-between"
		>
			<a href="https://app.ply.io" target="_blank">
				<SIcon name="new-log-with-text" width="44" />
			</a>
		</div>

		<div class="conetnet-container flex-column flex-centerize width-100 height-100">
			<div class="inner-content-container display-flex flex-column flex-justify-space-around flex-align-center">
				<div v-if="showProgressBar && !isMobile" class="progress-bar-container">
					<div
						:key="i"
						v-for="(prog, i) in filteredProgressBarItem"
						class="progress-item flex-centerize"
						:class="{ 'no-border': i === filteredProgressBarItem.length - 1, selected: selectedProgressIndex === i }"
					>
						<SIcon class="mt-1" v-if="selectedProgressIndex > i" name="successfull-connection" width="14" />
						<div v-else>{{ `${i + 1}.` }}</div>
						<div class="ml-1">
							{{ prog.text }}
						</div>
					</div>
				</div>
				<div class="flex-centerize flex-column">
					<div class="slot-card flex-column flex-centerize">
						<slot />
					</div>
					<slot name="bottom" />
				</div>
				<div class="width-100 mt-n2 px-8" v-if="isInstallationMode && !dontShowInstallationDetails">
					<div v-if="!hidePendingInstall" class="divider width-100" />
					<InstallablePreview :hidePendingInstall="hidePendingInstall" :installableId="installableId" />
				</div>
			</div>
		</div>
		<AppDialogManager />
	</div>
</template>
<script>
const VERIFY_EMAIL_TEXT = 'Verify email';
import InstallablePreview from '@/components/Project/InstallablePreview.vue';
import AppDialogManager from '@/components/dialogs/AppDialogManager/AppDialogManager';
import { WORKSPACE_SELECTION_ROUTE_NAME } from '@/router/router.const.js';
import { isInstallationRegistrationMode } from '@/utils/helpers';

const isMobile = require('is-mobile');
export default {
	name: 'UserRegistrationLayout',
	props: {
		hideTopBar: { type: Boolean },
		showProgressBar: { type: Boolean },
		isGoogleSignupMode: { type: Boolean },
		hidePendingInstall: { type: Boolean },
		dontShowInstallationDetails: { type: Boolean },
	},
	components: { InstallablePreview, AppDialogManager },
	computed: {
		isMobile() {
			return isMobile();
		},
		selectedProgressIndex() {
			return this.filteredProgressBarItem.findIndex((item) => item.routeNames.includes(this.$route.name.replace('Installation', '')));
		},
		filteredProgressBarItem() {
			return this.progressBarItems.filter((item) => !this.hideVerifyAccount || item.text !== VERIFY_EMAIL_TEXT);
		},
		hideVerifyAccount() {
			return Boolean(this.$route.params?.gtoken) || this.isGoogleSignupMode;
		},
		isInstallationMode() {
			return isInstallationRegistrationMode();
		},
		installableId() {
			return this.$route.params?.installableId;
		},
	},
	mounted() {},
	methods: {},
	data() {
		return {
			progressBarItems: [
				{ text: 'Create an account', routeNames: ['UserDetailsForm', WORKSPACE_SELECTION_ROUTE_NAME] },
				{ text: VERIFY_EMAIL_TEXT, routeNames: ['SignedUpSuccessfull'] },
				{ text: 'Install the extension', routeNames: ['InstallExtensionLink', 'PinExtension'] },
			],
		};
	},
};
</script>

<style scoped lang="scss">
.divider {
	height: 1px;
	margin-bottom: 2px;
	background: var(--border-color);
}
.slot-title {
	font-size: 22px;
	font-weight: bold;
	color: var(--primary-font-color);
}

.slot-title-description {
	font-size: 18px;
	color: var(--primary-font-color);
}
.user-registration-layout {
	width: 100vw;
	height: 100vh;
	background: var(--page-background);
	background-image: url('../../assets/icons/registration-background.png');
	overflow-y: auto;

	.header-container {
		height: 60px;
		padding: 8px 52px;
		@media (max-width: 600px) {
			padding: 16px;
		}
		background: var(--bg-color);
		border-bottom: 1px solid var(--border-color);
	}

	.conetnet-container {
		.inner-content-container {
			width: 820px;
			height: 827px;

			@media (max-width: 600px) {
				width: 100%;
			}
		}
		.slot-card {
			min-width: 470px;
			max-width: 760px;
			text-align: center;
			border-radius: 10px;
			background: var(--bg-color);
			padding: 38px 65px 28px 65px;
			@media (max-width: 600px) {
				min-width: calc(100% - 20px);
				max-width: calc(100% - 20px);
				padding: 18px 10px 28px 10px;
			}
			box-shadow: 0px 3px 6px var(--shadow-color);
		}
	}

	.footer-container {
		height: 60px;
	}
}
.progress-bar-container {
	height: 35px;
	display: flex;
	flex-direction: row;
	border-radius: 10px;
	border: 1px solid #d2d7e2;

	.progress-item {
		width: 250px;
		font-size: 14px;
		font-weight: 300;
		border-radius: 10px;
		color: var(--secondary-font-color);
		border-right: 1px solid var(--secondary-font-color);

		&.selected {
			font-weight: 600;
			background: var(--bg-color);
			color: var(--primary-font-color);
		}
		&.no-border {
			border: none;
		}
	}
}
</style>
